import { css } from 'styled-components';

const menuItemIndicatorColor = ({
  theme,
}: {
  theme: { color: { brightTurquoise: string } };
}) => theme.color.brightTurquoise;

/** Left offset for the vertical indicator in the community sidebar main column. */
export const COMMUNITY_SIDEBAR_INDICATOR_LEFT = '9px';

type SidebarMenuListItemHighlightOptions = {
  indicatorLeft?: string;
  includeActive?: boolean;
  includeFocusVisible?: boolean;
};

export const sidebarMenuListItemHighlight = ({
  indicatorLeft = '4px',
  includeActive = true,
  includeFocusVisible = true,
}: SidebarMenuListItemHighlightOptions = {}) => {
  const activeSelector = includeActive ? ', &.active' : '';
  const focusSelector = includeFocusVisible ? ', &:focus-visible' : '';

  return css`
    position: relative;
    transition: background 0.15s ease, color 0.15s ease;

    &::before {
      content: '';
      position: absolute;
      left: ${indicatorLeft};
      top: 50%;
      width: 3px;
      height: calc(100% - 12px);
      border-radius: 2px;
      background-color: ${menuItemIndicatorColor};
      transform: translateY(-50%) scaleY(0);
      transform-origin: center;
      transition: transform 0.15s ease;
      pointer-events: none;
    }

    &:hover${activeSelector}${focusSelector} {
      background-color: ${({ theme }) => theme.color.blackSqueeze};

      &::before {
        transform: translateY(-50%) scaleY(1);
      }
    }
  `;
};

/** Animated left bar when `::before` is already used (e.g. online status dot). */
export const sidebarMenuListItemHighlightAfter = ({
  indicatorLeft = '5px',
  includeActive = false,
}: SidebarMenuListItemHighlightOptions = {}) => {
  const activeSelector = includeActive ? ', &.active' : '';

  return css`
    position: relative;
    transition: background 0.15s ease, color 0.15s ease;

    &::after {
      content: '';
      position: absolute;
      left: ${indicatorLeft};
      top: 50%;
      width: 3px;
      height: calc(100% - 12px);
      border-radius: 2px;
      background-color: ${menuItemIndicatorColor};
      transform: translateY(-50%) scaleY(0);
      transform-origin: center;
      transition: transform 0.15s ease;
      pointer-events: none;
    }

    &:hover${activeSelector} {
      background-color: ${({ theme }) => theme.color.blackSqueeze};

      &::after {
        transform: translateY(-50%) scaleY(1);
      }
    }
  `;
};
